import React from 'react'
import moment from 'moment'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { Table, Text } from 'src/components/Ant'
import { R1Data } from 'src/store/ducks/reports/types'

const columns: ColumnProps<R1Data>[] = [
  {
    align: 'center',
    dataIndex: 'receipt_number',
    key: 'receipt_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.1.data.id'
  },
  {
    dataIndex: 'service_name',
    key: 'service_name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.1.data.service-name'
  },
  {
    dataIndex: 'receipt_date',
    key: 'receipt_date',
    render: (value: number) => (
      <Text>{moment.unix(value).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.1.data.date'
  },
  {
    dataIndex: 'image_number',
    key: 'image_number',
    render: (value: string) => <Text>{value && `#${value}`}</Text>,
    title: 'web.report.1.data.img',
    width: 50
  },
  {
    dataIndex: 'receipt_currency',
    key: 'receipt_currency',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.1.data.currency',
    width: 65
  },
  {
    align: 'right',
    dataIndex: 'receipt_enxange_rate',
    key: 'receipt_enxange_rate',
    render: (value: string, record: R1Data) => {
      if (
        record.receipt_type === 'VALUE' &&
        record.receipt_currency !== 'BRL'
      ) {
        return (
          <Text>
            {
              currencyMask({
                formatStr: true,
                precision: 4,
                value
              }).maskedValue
            }
          </Text>
        )
      }
      return null
    },
    title: 'web.report.1.data.exchange-rate',
    width: 65
  },
  {
    align: 'right',
    dataIndex: 'receipt_quantity',
    key: 'receipt_quantity',
    render: (value: string, record: R1Data) => {
      if (record.receipt_type === 'QUANTITY') {
        return <Text>{value}</Text>
      }
      return null
    },
    title: 'web.report.1.data.quantity',
    width: 65
  },
  {
    align: 'right',
    dataIndex: 'receipt_amount',
    key: 'receipt_amount',
    render: (value: string, record: R1Data) => {
      if (record.receipt_type === 'VALUE') {
        return (
          <Text>{currencyMask({ formatStr: true, value }).maskedValue}</Text>
        )
      }
      return null
    },
    title: 'web.report.1.data.amount',
    width: 65
  },
  {
    align: 'right',
    dataIndex: 'total',
    key: 'total',
    render: (value: string) => {
      return <Text>{currencyMask({ formatStr: true, value }).maskedValue}</Text>
    },
    title: 'web.report.1.data.total'
  }
]

function TableDetail({ ...props }: TableProps<R1Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
